<template>
    <div class="p-2 text-center font-sans text-gray-300 md:p-4">
    
        <BuySellContact />

      <h1 class="text-3xl mt-6">Choosing the Right Account for You</h1>
    

         
<h1 class="text-2xl mt-6">Read Listings Carefully</h1>

<p class="w-5/6 m-auto md:w-1/2">We encourage Sellers to provide as much information as possible. Before purchasing an account make sure to check the region is compatible!</p>

<p class="w-5/6 m-auto mt-2 md:w-1/2">If possible, try to purchase an account that has been played on with a similar CPU/GPU family (AMD/Nvidia/Intel). If you can find an exact match, that's even better!</p>

     
<h1 class="text-2xl mt-6">Stick to Trusted Sellers</h1>

<p class="w-5/6 m-auto mt-2 md:w-1/2">If you're worried about third-party sellers, look for listings from Sellers with <span class="text-red-500">red names that start with VA-</span>.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">These listings are from <span class="text-red-500">Valorant</span>Accounts Staff who provide the <router-link to="/boost" class="underline">In-House Boosting Service.</router-link></p>


<p class="w-5/6 m-auto mt-2 md:w-1/2">Still unsure? <router-link to="/contact" class="underline">Contact us</router-link> and we'll find an available, compatible listing just for you!</p>



</div>
</template>

<script>

import BuySellContact from './BuySellContact'

export default {
  name: 'ChoosingAccounts',
  data() {
    return {

    }
  },
  components: {BuySellContact},
 beforeMount(){

 },    

}
</script>


// WEBPACK FOOTER //
// src/components/ChoosingAccounts.vue